var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row gallery" },
    _vm._l(_vm.images, function(item, index) {
      return _c("div", { staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3" }, [
        _c("div", { staticClass: "thumbnail" }, [
          _c(
            "a",
            { attrs: { href: item.imageUrl, "data-image-id": item.id } },
            [_vm._v(_vm._s(item.filename))]
          ),
          _vm._v(" "),
          !_vm.readonly
            ? _c("p", { staticClass: "hidden-print" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.remove(item.id)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-trash-o",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v("Remove")
                  ]
                )
              ])
            : _vm._e()
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }